import { Routes } from '@angular/router';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { screeningRoutingResolver } from '../resolvers/screening-routing-resolver.service';

const SCREENING_TABS: Routes = [
  {
    path: '',
    loadComponent: () => import('../screening-overview.component').then((m) => m.ScreeningOverviewComponent),
    data: {
      title: extractTranslation('screening.tabs.screening_overview'),
      noBreadcrumb: true,
      faicon: 'users',
    },
  },
  {
    path: 'screening-config',
    loadComponent: () =>
      import('../components/screening-config-view/screening-config-view.component').then(
        (m) => m.ScreeningConfigViewComponent,
      ),
    data: {
      title: extractTranslation('screening.tabs.screening_config'), // 'Screening Config',
      noBreadcrumb: true,
      faicon: 'cog',
      tabbed: false,
    },
  },
  {
    path: 'screening-audit-log',
    loadComponent: () =>
      import('../components/screening-audit-log/screening-audit-log-view/screening-audit-log-view.component').then(
        (m) => m.ScreeningAuditLogViewComponent,
      ),
    data: {
      title: extractTranslation('screening.tabs.screening_audit_log'),
      noBreadcrumb: true,
      faicon: 'th-list',
      tabbed: false,
    },
  },
];

export const SCREENING_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full',
  },
  {
    path: 'create-screening-config',
    loadComponent: () =>
      import('../components/screening-config-view/screening-config-view.component').then(
        (m) => m.ScreeningConfigViewComponent,
      ),
    data: {
      title: extractTranslation('screening.tabs.screening_config'), // 'Screening Config',
      tabbed: false,
      hideAllBreadcrumbs: true,
    },
  },
  {
    path: 'overview',
    data: {
      title: extractTranslation('screening.tabs.screening_overview'),
      tabbed: true,
    },
    resolve: {
      resolvedInfo: screeningRoutingResolver,
    },
    children: [...SCREENING_TABS],
  },
  {
    path: 'customer-person',
    loadChildren: () => import('./customer-person-screening.routes').then((m) => m.SCREENING_CUSTOMER_PERSON_ROUTES),
    data: {
      title: extractTranslation('screening.tabs.customer_person.title'),
    },
  },
];
